export var Slugs;
(function (Slugs) {
    Slugs["About"] = "about";
    Slugs["Homepage"] = "homepage";
    Slugs["News"] = "news";
    Slugs["Show_News"] = "show-news";
    Slugs["Lang"] = "lang";
    Slugs["Digital_Grow"] = "digital-grow";
    Slugs["I_D"] = "i-d";
    Slugs["Projects"] = "projects";
    Slugs["Donation"] = "donation";
    Slugs["Mission"] = "mission";
    Slugs["Profile"] = "profile";
    Slugs["Strategy"] = "strategy";
    Slugs["Team"] = "team";
    Slugs["Projects_World"] = "projects-world";
    Slugs["Digital_Platform"] = "digital-platform";
    Slugs["Digital_Library"] = "digital-library";
    Slugs["COOKIE_POLICY"] = "cookies";
    Slugs["PRIVACY_POLICY"] = "privacy-policy";
    Slugs["Newsletter"] = "newsletter";
    Slugs["SITE_MAP"] = "site-map";
})(Slugs || (Slugs = {}));
